// extracted by mini-css-extract-plugin
export default {"logoHeightSmall":"30px","logoHeightMedium":"45px","logoHeightLarge":"60px"};